export default "__VITE_ASSET__CQUAmsjR__"